module.exports = __webpack_public_path__ + "75cd27e0a3b60094149587a2ffa7b88b.pdf";